import styled from "styled-components";
import colors from "../../assets/style/colors";

const LayoutStyle = styled.div``;
export default LayoutStyle;
